import React, { useState, useContext, useEffect } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import { Grid } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { getStorage } from 'src/utils/utils';
import { useTranslation } from 'react-i18next';

import PageWrapper from 'src/layout/PageWrapper/PageWrapper';
import Page from 'src/layout/Page/Page';
import Humans from 'src/assets/img/scene4.png';
import HumansWebp from 'src/assets/img/scene4.webp';
import { demoPagesMenu, dashboardPagesMenu } from 'src/menu';
import { CardFooter, CardFooterLeft, CardFooterRight } from 'src/components/bootstrap/Card';
import Pagination, { PaginationItem } from 'src/components/bootstrap/Pagination';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';

import Icon from 'src/components/icon/Icon';
import { BsArrowClockwise } from 'react-icons/bs';
import { BsSearch } from 'react-icons/bs';
import { BsArrowBarDown } from 'react-icons/bs';

import { PaymentServices } from 'src/services/PaymentServices';
import ThemeContext from 'src/contexts/themeContext';
import useDeviceScreen from 'src/hooks/useDeviceScreen';
import TablePagination from '@mui/material/TablePagination';
import { MdOutlineSettings } from 'react-icons/md';
import { BsBank2 } from 'react-icons/bs';
import { BsTrash } from 'react-icons/bs';

import showNotification from 'src/components/extras/showNotification';

// MODAL
import ModalEdit from './ModalEditProvider';
import ModalAdbank from './ModalAddbank';
import ModalUserBankEdit from './ModalUserBankEdit';
import ModalTranferMoney from './ModalTranferMoney';
import ModalConfirm from './ModalConfirm';

export const PER_COUNT = {
	10: 10,
	20: 20,
	50: 50,
	100: 100,
};

export default function Settlements() {
	const { t } = useTranslation();
	const { asideStatus } = useContext(ThemeContext);
	const { width } = useDeviceScreen();

	const [userBankListEdit, setUserBankListEdit] = useState([]);
	const [bankList, setBankList] = useState([]);
	const [dataTranfer, setDataTranfer] = useState([]);
	const [provider, setProvider] = useState([]);
	const [userBankList, setUserBankList] = useState([]);
	const [settlement, setSettlements] = useState([]);
	const [page, setPage] = useState(1);
	const [pageLimit, setPageLimit] = useState(10);
	const [toTalpage, setToTalpage] = useState(0);
	const [meta, setMeta] = useState();
	const [perPage, setPerPage] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalAmount, setTotalAmount] = useState([]);

	const [isOpenUserBank, setIsOpenUserBank] = useState(false);
	const [isOpenAddbank, setIsOpenAddbank] = useState(false);
	const [isOpenTranfer, setIsOpenTranfer] = useState(false);
	const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
	const [dataAddbank, setDataAddbank] = useState([]);

	const [totalItems, setTotalItems] = useState(0);
	const [totalPage, setTotalPage] = useState(0);

	const [paymentName, setPaymentName] = useState('');
	const [delBankUserId, setDelBankUserId] = useState('');
	const [titileNameConfirm, setTitileNameConfirm] = useState('');
	const [detailConfirm, setDetailConfirm] = useState('');
	const [tranRef, setTranRef] = useState('');
	const [timeQuery, setTimeQuery] = useState([
		moment().startOf('month'),
		moment().endOf('month'),
	]);
	const [status, setStatus] = useState('');

	const handleDelBankUser = () => {
		PaymentServices.delUserBank(delBankUserId)
			.then(() => {
				setIsOpenModalConfirm(false);
				fetchSumSettlements();
				fetchListUserBank();
				showNotification(
					<span className='d-flex align-items-center'></span>,
					`${t('txt_successfully')}`,
				);
			})
			.catch((err) => {
				showNotification(
					<span className='d-flex align-items-center'></span>,
					`${err?.response?.data?.message}`,
				);
			});
	};

	const handleSubmitUserBankEdit = async () => {
		const data = [];
		for (const item of bankList) {
			if (item?.bank_code === userBankListEdit?.bank_code) {
				data.push({
					...userBankListEdit,
					bank_name: item?.bank_name,
				});
			}
		}

		await PaymentServices.updateUserBank(data[0], data[0]?._id)
			.then(() => {
				setIsOpenUserBank(false);
				fetchSumSettlements();
				fetchListUserBank();
				showNotification(
					<span className='d-flex align-items-center'></span>,
					`${t('txt_successfully')}`,
				);
			})
			.catch((err) => {
				showNotification(
					<span className='d-flex align-items-center'></span>,
					`${err?.response?.data?.message}`,
				);
			});
	};

	const onChangeDataEditUserBannk = (event, type) => {
		if (event.target) {
			let { name, value } = event.target;

			setUserBankListEdit((prevState) => ({
				...prevState,
				[name]: value,
			}));
		}
	};

	const handleTranferMoney = (item) => {
		setIsOpenTranfer(true);
		setDataTranfer(item);
	};

	const handleEditBankUser = (record) => {
		setIsOpenUserBank(true);
		setUserBankListEdit((prevState) => ({
			...prevState,
			bank_code: record?.bank_code,
			bank_nickname: record?.bank_nickname,
			bank_account_name: record?.bank_account_name,
			bank_account_number: record?.bank_account_number,
			_id: record?._id,
		}));
	};

	const handleSearch = () => {
		fetchSumSettlements();
	};

	const dataStatus = [
		{
			name: `${t('txt_all_status')}`,
			value: '',
		},
		{
			name: `${t('txt_processing')}`,
			value: 'processing',
		},
		{
			name: `${t('txt_rejected')}`,
			value: 'rejected',
		},
		{
			name: `${t('txt_success')}`,
			value: 'success',
		},
	];

	const handleEvent = (event, picker) => {
		console.log('handleEvent : ', moment(picker.startDate).format('DD/MM/YYYY'));
	};

	const handleCallback = (start, end, label) => {
		setTimeQuery([moment(start), moment(end)]);
	};

	const handleSubmit = () => {
		if (!dataAddbank?.bank_code) {
			showNotification(
				<span className='d-flex align-items-center'></span>,
				`${t('txt_please_select_bank')}`,
			);
		} else {
			PaymentServices.createUserBank(dataAddbank)
				.then(() => {
					setIsOpenAddbank(false);
					fetchListUserBank();
					showNotification(
						<span className='d-flex align-items-center'></span>,
						`${t('txt_successfully')}`,
					);
				})
				.catch((err) => {
					showNotification(
						<span className='d-flex align-items-center'></span>,
						`${err?.response?.data?.message}`,
					);
				});
		}
	};

	const onChangeData = (event, type) => {
		if (event.target) {
			let { name, value } = event.target;

			setDataAddbank((prevState) => ({
				...prevState,
				[name]: value,
			}));
		}
	};

	const handleRefresh = () => {
		fetchSumSettlements();
		fetchListUserBank();
		showNotification(
			<span className='d-flex align-items-center'>
				{/* <Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span> */}
			</span>,
			`${t('txt_the_latest_information')}`,
		);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setPageLimit(parseInt(event.target.value, 10));
		setPage(0);
	};

	// BANK

	const fetchBankList = () => {
		PaymentServices.getBanklist()
			.then(({ data }) => {
				const arr1 = [
					{
						bank_code: '',
						bank_name: '',
						bank_name_th: `${t('txt_please_select_bank')}`,
					},
				];
				setBankList([...arr1, ...data]);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const fetchListUserBank = () => {
		PaymentServices.getListuserbank()
			.then(({ data }) => {
				setUserBankList(data?.items);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const fetchSumSettlements = () => {
		let payload = {
			dateStart: timeQuery[0].format('YYYY/MM/DD'),
			dateEnd: timeQuery[1].format('YYYY/MM/DD'),
			paymentName: paymentName,
			status: status,
			page: currentPage,
			limit: perPage,
			refId: tranRef,
			token: getStorage('token'),
		};

		PaymentServices.getSummarySettlements(payload)
			.then(({ data }) => {
				setTotalAmount(data?.summary);
				setSettlements(data?.items);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const getInfo = () => {
		const start = perPage * (currentPage - 1) + 1;

		const end = perPage * currentPage;

		return (
			<span className='pagination__desc'>
				{t('txt_showing')} {start} {t('txt_to')} {end > totalItems ? totalItems : end}{' '}
				{t('txt_of')} {totalItems} {t('txt_list')}
			</span>
		);
	};

	const pagination = () => {
		let items = [];

		let i = currentPage - 1;
		while (i >= currentPage - 1 && i > 0) {
			items.push(
				<PaginationItem key={i} onClick={() => setCurrentPage(currentPage - 1)}>
					{i}
				</PaginationItem>,
			);

			i -= 1;
		}

		items = items.reverse();

		items.push(
			<PaginationItem key={currentPage} isActive onClick={() => setCurrentPage(currentPage)}>
				{currentPage}
			</PaginationItem>,
		);

		i = currentPage + 1;
		while (i <= currentPage + 1 && i <= totalPage) {
			items.push(
				<PaginationItem key={i} onClick={() => setCurrentPage(currentPage + 1)}>
					{i}
				</PaginationItem>,
			);

			i += 1;
		}

		return items;
	};

	const convertDate = (data) => {
		const convert = moment(data).format('DD/MM/YYYY - HH:mm:ss');
		return convert;
	};

	const ccyFormat = (num) => {
		return `${typeof num === 'number' ? num?.toFixed(2) : '0.00'}`;
	};

	useEffect(() => {
		fetchSumSettlements();
	}, [timeQuery, status, currentPage, perPage]);

	useEffect(() => {
		fetchBankList();
		fetchListUserBank();
	}, []);

	return (
		<PageWrapper title={dashboardPagesMenu.settlements.text}>
			<Page>
				<div
					style={{ margin: asideStatus || width < 768 ? '' : '0rem 1.5rem' }}
					className='div_founding_container'>
					<div className='fw-bold h3'>{t('txt_settlements')}</div>
					<div className='div_found_in_transection mt-3'>
						<div className='fw-bold h5'>{t('txt_manageMent')}{t('txt_settlements')}</div>
						<div>
							<Button
								onClick={() => {
									setIsOpenAddbank(true);
								}}
								className='btn_refresh'>
								<BsBank2 size={15} />
								<span>{t('txt_add_bank')}</span>
							</Button>
							<Button
								style={{ marginLeft: '8px' }}
								onClick={() => handleRefresh()}
								className='btn_refresh'>
								<BsArrowClockwise size={15} />
								<span>{t('txt_refresh')}</span>
							</Button>
						</div>
					</div>

					<Grid container spacing={2} sx={{ mt: '0.5rem', mb: '2rem' }}>
						<Grid item xs={12} md={12} xl={4} lg={4}>
							<DateRangePicker
								initialSettings={{
									startDate: timeQuery[0],
									endDate: timeQuery[1],
								}}
								onEvent={(e, picker) => handleEvent(e, picker)}
								onCallback={(start, end, label) =>
									handleCallback(start, end, label)
								}>
								<input type='text' className='form-control input_type_date' />
							</DateRangePicker>
						</Grid>
						<Grid item xs={12} md={12} xl={4} lg={4}>
							<div className='div_search'>
								<FormGroup>
									<Input
										placeholder=''
										className='input_search'
										type='text'
										value={tranRef}
										onChange={(e) => setTranRef(e.target.value)}
									/>
								</FormGroup>
								<Button onClick={() => handleSearch()} className='btn_search'>
									<BsSearch size={15} />
									<span>{t('txt_search')}</span>
								</Button>
							</div>
						</Grid>

						<Grid item xs={12} md={12} xl={4} lg={4}>
							<div className='div_select'>
								<Select
									style={{ height: '40px' }}
									ariaLabel='Status'
									onChange={(e) => {
										setStatus(e.target.value);
									}}
									value={status}>
									{dataStatus?.map((item) => {
										return (
											<Option key={item} value={item?.value}>
												{item?.name}
											</Option>
										);
									})}
								</Select>
							</div>
						</Grid>
					</Grid>

					<div className='div_filter_found_in'></div>

					{settlement?.length > 0 ? (
						<>
							<div className='div_table_found_in'>
								<table class='table table-striped'>
									<thead>
										<tr>
											<th scope='col'>{t('txt_create_at')}</th>
											<th scope='col'>REF 1</th>
											<th scope='col'>{t('txt_account_name')}</th>
											<th scope='col'>{t('txt_account_number')}</th>
											<th scope='col'>{t('txt_bank')}</th>
											<th scope='col'>{t('txt_amount')}</th>
											<th scope='col'>{t('txt_fee')}</th>
											<th scope='col'>{t('txt_balance')}</th>
											<th scope='col'>{t('txt_user_created')}</th>
											<th scope='col'>{t('txt_status')}</th>
										</tr>
									</thead>
									<tbody>
										{settlement?.map((item, idx) => {
											return (
												<tr key={idx}>
													<th scope='row'>
														{convertDate(item?.createdAt)}
													</th>
													<td>{item?.ref_id}</td>
													<td>{item?.account_name}</td>
													<td>{item?.account_number}</td>
													<td>{item?.bank_code}</td>
													<td>
														<NumericFormat
															value={ccyFormat(item?.amount)}
															thousandSeparator
															displayType={'text'}
														/>
													</td>
													<td>{item?.downline_fee}</td>
													<td>
														<NumericFormat
															value={ccyFormat(item?.downline_amount)}
															thousandSeparator
															displayType={'text'}
														/>
													</td>
													<td>{item?.user_created?.username}</td>
													<td>{item?.status}</td>
													<td style={{ textAlign: 'center' }}></td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>

							<div className='div_filter_found_in'>
								<CardFooter style={{ overflow: 'scroll' }}>
									<CardFooterLeft>
										<span className='text-muted'>{getInfo()}</span>
									</CardFooterLeft>
									<CardFooterRight className='d-flex'>
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												textWrap: 'nowrap',
											}}>
											<span>
												{t('txt_amount')} :&nbsp;
												<NumericFormat
													value={ccyFormat(totalAmount?.amount)}
													thousandSeparator
													displayType={'text'}
												/>
												&nbsp;{t('txt_THB')}
											</span>
											<span style={{ marginLeft: '5px' }}>
												{t('txt_total_amount')} :{' '}
												<NumericFormat
													value={ccyFormat(totalAmount?.downline_amount)}
													thousandSeparator
													displayType={'text'}
												/>
												&nbsp;{t('txt_THB')}
											</span>
										</div>
										{totalPage > 0 && (
											// @ts-ignore
											<Pagination ariaLabel={'xxx'}>
												<PaginationItem
													isFirst
													isDisabled={!(currentPage - 1 > 0)}
													onClick={() => setCurrentPage(1)}
												/>
												<PaginationItem
													isPrev
													isDisabled={!(currentPage - 1 > 0)}
													onClick={() => setCurrentPage(currentPage - 1)}
												/>
												{currentPage - 1 > 1 && (
													<PaginationItem
														onClick={() =>
															setCurrentPage(currentPage - 2)
														}>
														...
													</PaginationItem>
												)}
												{pagination()}
												{currentPage + 1 < totalPage && (
													<PaginationItem
														onClick={() =>
															setCurrentPage(currentPage + 2)
														}>
														...
													</PaginationItem>
												)}
												<PaginationItem
													isNext
													isDisabled={!(currentPage + 1 <= totalPage)}
													onClick={() => setCurrentPage(currentPage + 1)}
												/>
												<PaginationItem
													isLast
													isDisabled={!(currentPage + 1 <= totalPage)}
													onClick={() => setCurrentPage(totalPage)}
												/>
											</Pagination>
										)}

										<Select
											style={{ width: 'auto' }}
											size='sm'
											ariaLabel='Per'
											onChange={(e) => {
												setPerPage(parseInt(e.target.value, 10));
												setCurrentPage(1);
											}}
											value={perPage.toString()}>
											{Object.keys(PER_COUNT).map((i) => (
												<Option key={i} value={i}>
													{i}
												</Option>
											))}
										</Select>
									</CardFooterRight>
								</CardFooter>
							</div>
						</>
					) : (
						<div className='div_list_none fw-bold h5'>
							{t('txt_there_are_no_items')}
						</div>
					)}

					<div className='div_settlements_bank'>
						<p className='p_list_bank'>{t('txt_bank_list')}</p>
						{userBankList?.length > 0 ? (
							<div className='div_table_found_in'>
								<table class='table table-striped'>
									<thead>
										<tr>
											<th scope='col'>{t('txt_create_at')}</th>
											<th scope='col'>{t('txt_update_at')}</th>
											<th scope='col'>{t('txt_name')}</th>
											<th scope='col'>{t('txt_bank_name')}</th>
											<th scope='col'>{t('txt_account_number')}</th>
											<th scope='col' style={{ textAlign: 'center' }}>
												{t('txt_action')}
											</th>
										</tr>
									</thead>
									<tbody>
										{userBankList?.map((item, idx) => {
											return (
												<tr key={idx}>
													<th>{convertDate(item?.createdAt)}</th>
													<td>{convertDate(item?.updatedAt)}</td>
													<td>{item?.bank_account_name}</td>
													<td>{item?.bank_name}</td>
													<td>{item?.bank_account_number}</td>
													<td style={{ textAlign: 'center' }}>
														<div className='div_icon_action'>
															<BsArrowBarDown
																className='svg_transfer_money'
																onClick={() =>
																	handleTranferMoney(item)
																}
															/>
															<MdOutlineSettings
																className='svg_edit'
																onClick={() =>
																	handleEditBankUser(item)
																}
															/>
															<BsTrash
																className='svg_delete'
																onClick={() => {
																	setIsOpenModalConfirm(true);
																	setDelBankUserId(item?._id);
																	setTitileNameConfirm(
																		'Warning !',
																	);
																	setDetailConfirm(
																		t(
																			'txt_do_you_want_to_delete_this_item',
																		),
																	);
																}}
															/>
														</div>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						) : (
							<div className='div_list_none fw-bold h5'>
								{t('txt_there_are_no_items')}
							</div>
						)}
					</div>
				</div>
				<ModalAdbank
					handleSubmit={handleSubmit}
					dataAddbank={dataAddbank}
					handleChangeData={onChangeData}
					isOpen={isOpenAddbank}
					exit={() => setIsOpenAddbank(false)}
					bankList={bankList}
					t={t}
				/>

				<ModalUserBankEdit
					handleSubmit={handleSubmitUserBankEdit}
					data={userBankListEdit}
					handleChangeData={onChangeDataEditUserBannk}
					isOpen={isOpenUserBank}
					exit={() => setIsOpenUserBank(false)}
					bankList={bankList}
					t={t}
				/>
				<ModalTranferMoney
					isOpen={isOpenTranfer}
					exit={() => setIsOpenTranfer(false)}
					data={dataTranfer}
					fetchSumSettlements={fetchSumSettlements}
					t={t}
				/>
				<ModalConfirm
					isOpen={isOpenModalConfirm}
					exit={() => setIsOpenModalConfirm(false)}
					title={titileNameConfirm}
					des={detailConfirm}
					handleConfirm={handleDelBankUser}
					t={t}
				/>
			</Page>
		</PageWrapper>
	);
}
